import { registerOverlayResetHandler } from '../../shared/ports/sessionResetPort';
import { usePosOverlayStore } from '../store/usePosOverlayStore';
import { usePosCheckoutStore } from '../store/usePosCheckoutStore';
import { usePosCashSessionStore } from '../store/usePosCashSessionStore';
import { usePosStore } from '../store/usePosStore';

registerOverlayResetHandler(() => {
  usePosOverlayStore.getState().resetAll();
  usePosCheckoutStore.getState().resetCheckout();
  usePosCashSessionStore.getState().markCashSessionPendingForBranch(null);
});

registerOverlayResetHandler(() => {
  usePosStore.getState().clearCart();
});
